import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  protected http: HttpClient;
  protected baseUrl: string;
  protected transSvc: TranslateService;
  private currentLanguage: string;

  constructor(injector: Injector) {
    this.http = injector.get(HttpClient);
    const baseHref = injector.get(APP_BASE_HREF);
    this.transSvc = injector.get(TranslateService);

    this.currentLanguage = this.transSvc.currentLang || this.transSvc.defaultLang;

    this.transSvc.onLangChange.subscribe((value: LangChangeEvent) => {
      this.currentLanguage = value.lang;
      this.baseUrl = baseHref + '/' + value.lang + '/';
    });
    this.baseUrl = baseHref + '/' + this.currentLanguage + '/';
  }

  public get languageCode(): string {
    return this.currentLanguage;
  }

  public getErrorFromResponse(err: HttpErrorResponse): string {
    if (err.error instanceof Error) {
      const error = err.error;
      return error.message;
    } else if (err.error && typeof err.error === 'object') {
      const errObject = err.error;
      return errObject.ExceptionMessage || errObject.Message;
    } else if (typeof err.error === 'string') {
      return `HTTP ${err.status} ${err.statusText}: ` + err.error.split('\r')[0];
    } else if (err.message) {
      return err.message;
    } else {
      return err.status + ' (status ' + err.statusText + ')';
    }
  }

  public getFromHost(apiPath: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.baseUrl + apiPath, {
        params: params
      }).subscribe((reply: any) => {
        resolve(reply);
      }, (err: HttpErrorResponse) => {
        reject(this.getErrorFromResponse(err));
      });
    });
  }

  public putToHost(apiPath: string, params: any, options?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(this.baseUrl + apiPath, params, options).subscribe((reply: any) => {
        resolve(reply);
      }, (err: HttpErrorResponse) => {
        reject(this.getErrorFromResponse(err));
      });
    });
  }

  public postToHost(apiPath: string, params: any, options?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.baseUrl + apiPath, params, options).subscribe((reply: any) => {
        resolve(reply);
      }, (err: HttpErrorResponse) => {
        reject(this.getErrorFromResponse(err));
      });
    });
  }
}
